import wrapper from 'wrapper';

class Chart {
    constructor(options = {}) {
        this.setDefaults(options);
        this.data = wrapper.getConfig().app.data;
        this.dateRange = wrapper.getConfig().app.dateRange;
        this.rtl = wrapper.getConfig().textDirection === 'rtl';
        this.region = null;

        this.render();

        this.setupEventListeners();
        this.resize();
        this.repositionDateRange();
    }

    setupEventListeners() {
        window.onresize = () => this.resize();

        window.addEventListener('pocket-status-changed', () => this.resize());

        window.addEventListener('updated-filter', (e) => {
            this.region = e.detail === 'region_world' ? null : e.detail;
            this.repositionDateRange();
        });

        window.addEventListener('updated-sort', () => {
            this.repositionDateRange();
        });
    }

    setDefaults(options) {
        this.containerClass = options.containerClass || 's-c';
        this.newCasesClass = options.newCasesClass || 'c__h--n';
        this.dateRangeClass = options.dateRangeClass || 'core-date-range';
        this.svgClass = options.svgClass || 's-e';
        this.padding = options.padding || 16;
        this.showBorder = options.showBorder || false;
    }


    getContainers(parentClass) {
        const parentQuery = parentClass ? `.${parentClass} > ` : '';
        const containers = wrapper.selectAll(`${parentQuery}.${this.containerClass}`);
        return Array.prototype.slice.call(containers); // Convert NodeList to Array for IE
    }

    getDataForContainer(container) {
        const { iso } = container.parentNode && container.parentNode.dataset;
        if (iso) {
            const filtered = this.data.filter(d => d.iso === iso);
            if (filtered.length) {
                return filtered[0];
            }
        }
        return null;
    }

    updateDimensions() {
        const container = wrapper.scope.querySelector(`.${this.newCasesClass}`);
        this.width = container.clientWidth - (this.padding * 2);
    }

    getBrackets(dataItem) {
        return dataItem['time_series'].map(ts => ts[2]);
    }

    getDateRange() {
        if (this.dateRange && this.dateRange.formatted) {
            return this.dateRange.formatted;
        }
        return null;
    }

    renderDates() {
        const { start, end } = this.getDateRange();

        return `<div class="${this.dateRangeClass}" aria-hidden="true"><div>${start}</div><div>${end}</div></div>`;
    }

    render() {
        this.updateDimensions();

        this.getContainers().forEach((c, i) => {
            const container = c;
            const data = this.getDataForContainer(container);

            container.innerHTML = this.createSvg(data);
            if (i === 0) {
                container.innerHTML += this.renderDates();
                container.parentNode.classList.add('top');
            }
        });
    }

    strokeWidth(dataLength) {
        return this.width / ((1.1 * dataLength) - 0.1);
    }

    createSvg(dataItem) {
        const brackets = this.getBrackets(dataItem);
        const strokeWidth = this.strokeWidth(brackets.length);
        const border = this.showBorder ? '<rect class="r" />' : '';
        const lines = brackets.map((bkt, i) => {
            const x = this.x(i, strokeWidth);
            return `<line class="l-${bkt}" x1="${x}" y1="0" x2="${x}" y2="100%" stroke-width="${strokeWidth}" />`;
        });

        return `<svg class="${this.svgClass}">${lines.join('')}${border}</svg>`;
    }

    updateSvg(container) {
        const dataItem = this.getDataForContainer(container);
        const brackets = this.getBrackets(dataItem);
        const strokeWidth = this.strokeWidth(brackets.length);
        const svg = container.querySelector('svg');

        const lines = Array.prototype.slice.call(svg.querySelectorAll('line')); // Convert NodeList to Array for IE
        lines.forEach((line, i) => {
            const x = this.x(i, strokeWidth);

            line.setAttribute('x1', x);
            line.setAttribute('x2', x);
            line.setAttribute('stroke-width', strokeWidth);
        });
    }

    x(index, strokeWidth) {
        const x = (index * (1.1 * strokeWidth)) + (strokeWidth / 2);
        return this.rtl ? this.width - x : x;
    }

    repositionDateRange() {
        const { region } = this;
        const dateRange = wrapper.select(`.${this.dateRangeClass}`);
        wrapper.selectAll('.top').forEach(e => e.classList.remove('top'));

        const container = this.getContainers(region)[0];
        container.appendChild(dateRange);
        container.parentNode.classList.add('top');
    }

    resize() {
        this.updateDimensions();
        this.getContainers().forEach(c => {
            this.updateSvg(c);
        });
    }
}

export default Chart;
